<img class="img-circle" [src]="avatarSrc" [alt]="name" [width]="size" [height]="size"/>